/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SidebarItem } from "./SidebarItem";
import { SidebarItemListProps, UISidebarProps, Item } from "./types";

type Props = SidebarItemListProps & UISidebarProps;

export function SidebarItemList({
  items,
  hasSubtitle,
  hasIcon,
  onSubmit,
  name,
  selectedOptions,
}: Props) {
  return (
    <>
      {items.map((item: Item) => (
        <SidebarItem
          key={`${item.label}${item.value}`}
          hasSubtitle={hasSubtitle}
          hasIcon={hasIcon}
          name={name}
          item={item}
          onSubmit={() => onSubmit(item?.value ?? "")}
          selectedOptions={selectedOptions}
        />
      ))}
    </>
  );
}
